import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-operation",
  "use": "icon-operation-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-operation\"><defs><style type=\"text/css\"></style></defs><path d=\"M899.4 139.5H121.3c-14.3 0-25.9 11.8-25.9 26.3s11.6 26.3 25.9 26.3h25.9v499.3c0 29 23.2 52.6 51.9 52.6H318l-91.7 92.9c-6.7 6.6-9.4 16.4-7.1 25.6 2.4 9.2 9.5 16.4 18.5 18.8 9.1 2.4 18.7-0.3 25.2-7.2L391.4 744h237.9l128.4 130c10.2 10 26.4 9.8 36.4-0.3 10-10.1 10.1-26.5 0.3-36.8L702.6 744h119c28.6 0 51.9-23.5 51.9-52.6V192.1h25.9c14.3 0 25.9-11.8 25.9-26.3s-11.6-26.3-25.9-26.3zM742.7 387.7L601.4 527.5c-4.9 4.9-11.6 7.6-18.5 7.6s-13.6-2.7-18.5-7.6l-104.1-103L315 568.2c-6.6 6.7-16.3 9.4-25.4 7.1-9.1-2.4-16.3-9.4-18.7-18.5-2.4-9 0.3-18.7 7.1-25.2l163.8-162c10.2-10.1 26.8-10.1 37 0l104.1 102.9 122.8-121.4c6.6-6.5 16.2-9.1 25.3-6.7 9 2.4 16.1 9.4 18.5 18.3 2.4 9-0.2 18.5-6.8 25z\" p-id=\"11464\" fill=\"#bfcbd9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/operation.svg
// module id = Dh6m
// module chunks = 168